import { render, staticRenderFns } from "./CalendarOrdersSubMenu.vue?vue&type=template&id=7bd5dc9e&scoped=true&"
import script from "./CalendarOrdersSubMenu.vue?vue&type=script&lang=js&"
export * from "./CalendarOrdersSubMenu.vue?vue&type=script&lang=js&"
import style0 from "./CalendarOrdersSubMenu.vue?vue&type=style&index=0&id=7bd5dc9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd5dc9e",
  null
  
)

export default component.exports